module.exports = __webpack_public_path__ + "static/media/x-lg.f7983837.svg";